import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function OsnoviPreduzetnistva() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Osnovi preduzetništva" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Osnovi preduzetništva</h2>
              <p>
                <strong>Studijski program:</strong> Računovodstvo finansije i
                bankarstvo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Osnovi preduzetništva
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> Poslovna ekonomika; Menadžment
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Osnovni cilj predmeta je da studentima predstavi osnove
                preduzetništva, karakteristike i specifičnosti preduzetničkog
                poduhvata. Cilj ovog predmeta je da u sažetom obliku prikaže
                istorijski razvoj preduzetništva, odabrana iskustva i poglede na
                preduzetništvo u zemljama sa razvijenom tržišnom privredom i
                zemljama u tranziciji, kao i perspektive razvoja preduzetništva
                kod nas i na globalnom nivou.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Na osnovu stečenog znanja, studenti su osposobljeni da: definišu
                biznis ideju, istraže tržište, izaberu djelatnost, analitično
                sagledaju tržište i konkurenciju, planiraju troškove, selektuju
                adekvatna poslovna sredstva, izaberu odgovarajuće ljudske
                resurse, napišu i primjene biznis plan i biznis kanvas model,
                istraže i izaberu optimalne izvore finansiranja, minimiziraju
                rizike i maksimiziraju prednosti. Takođe, studenti su
                osposobljeni da: samostalno i timski rade, rješavaju stresne
                situacije, samostalno, grupno i interaktivno rješavaju probleme,
                komuniciraju sa dobavljačima i kupcima savremenim tehnološkim
                sredstvima, uspješno prezentiraju svoje zamisli i kvalitete svog
                proizvoda, izrađuju biznis plan i na osnovu njega osnuju
                sopstveno preduzeće, njeguju preduzetnički duh i stvaraju
                podržavajuće okruženje za inovacije i promjene.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Teorijska nastava: Shvatanje preduzetništva i njegova veza sa
                društvom i preduzećem; Pojam, cilj, zadatak i rezultati
                preduzetništva; Istorija preduzetništva; Preduzetnik i njegove
                karakteristike; Odlike vrhunskih preduzetnika; Preduzetništvo i
                menadžment; Mikro, mala i srednja preduzeća i preduzetništvo;
                Inovacije i rast kao djelovi preduzetništva; Preduzetnik, rizici
                i stres; Odakle se regrutuju preduzetnici u najrazvijenijim
                zemljama; Operativno koncipiranje preduzetničkog biznisa; Biznis
                plan, biznis kanvas model i njihove karakteristike; Biznis plan
                na osnovu definisane biznis ideje; Izrada biznis plana;
                Strategijski biznis plan; Biznis plan za novoosnovano preduzeće;
                Testovi i vježbe; Uspješni primjeri. Praktična nastava prati
                teorijsku nastavu.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: predavanja, vježbe,
                konsultacije, posjete/gostovanja uspješnim preduzetnicima.
                Predavanja se izvode uz korišćenje prezentacija i dodatna
                objašnjenja profesora. Praktična nastava prati teorijska
                predavanja uz primjenu sledećih važnijih metoda: interaktivni
                rad, pojedinačne i grupne prezentacije, analiza praktičnih
                slučajeva, simulacija različitih uloga. U izvođenju nastave na
                predmetu osnove preduzetništva koriste se savremene metode
                izvođenja nastave. To se postiže upotrebom savremenih alata i
                tehnika. Predavanja i vježbe organizovani su u slušaonama, a
                nekada i eksterno u toku studijskih posjeta preduzetnicima.
                Sofisticirani pedagoški pristup nastavi podrazumijeva adekvatnu
                i kvalitetnu pripremu predavanja kako u smislu sadržaja tako i u
                metodološkom smislu. Korišćenjem konvencionalnih i savremenih
                alata i tehnika postiže se optimalan balans. Upotreba
                informaciono komunikacionih tehnologija je imperativ
                osavremenjivanja nastave. Upotreba raznih prezentacija,
                infografika, naučnih portala i korišćenje društvenih mreža,
                jutjub kanala, mobilnih aplikacija, vještačke inteligencije kao
                i online povezivanje su neophodni u nastavi. Takođe korišćenje
                filma kao metode izvođenja nastave sastavni je dio predavanja
                ili kao domaći zadatak. U realizaciji predavanja i vježbi
                učestvuju predmetni nastavnici i saradnici, kao i gostujući
                profesori i istaknuti stručnjaci iz privrede. U nastavi se na
                kreativan način koriste kontrolisani eksperimenti, razne
                simulacije, pregled štampe i aktuelnosti, zanimljive igre,
                takmičenja i hakatoni.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P + 2V</td>
                    <td>
                      Shvatanje preduzetništva i njegova veza sa preduzećem i
                      društvom
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P + 2V</td>
                    <td>
                      Pojam, cilj, zadatak i rezultati preduzetništva; Istorija
                      preduzetništva
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P + 2V</td>
                    <td>
                      Preduzetnik i njegove karakteristike; Odlike vrhunskih
                      preduzetnika; Preduzetništvo i menadžment; Mikro, mala i
                      srednja preduzeća i preduzetništvo
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P + 2V</td>
                    <td>Metodologije izrade biznis planova; Uvod u plan</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P + 2V</td>
                    <td>
                      Sažeti poslovni model i opis plana; Preduzetnički
                      poduhvat; Biznis ideja-početak
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>2P + 2V</td>
                    <td>
                      Opis poslovnog područja i odabranog biznisa; Inovacije i
                      rast kao faktori uspjeha preduzetništva
                    </td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P + 2V</td>
                    <td>Operativno koncipiranje preduzetničkog biznisa</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P + 2V</td>
                    <td>Marketing plan i prodaja</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P + 2V</td>
                    <td>Menadžment i struktura organizacije</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P + 2V</td>
                    <td>Faktori uspjeha i procjena rizika</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P + 2V</td>
                    <td>Ekonomsko-finansijski plan</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P + 2V</td>
                    <td>Prilozi uz biznis planove; Testovi i vježbe</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P + 2V</td>
                    <td>
                      Prezentacije biznis planova, prezentacije poslovnih
                      modela; Primjeri uspješno realizovanih biznisa
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da prate nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4 č / 180min</td>
                            <td>Ukupno: 120 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 2 č / 90min</td>
                            <td>Nastava + završni ispit: 90 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 90min</td>
                            <td>Priprema i ovjera semestra: 9 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 21 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default OsnoviPreduzetnistva;
